export default __webpack_public_path__ + "static/media/course_header.b67a4d17.jpg";